import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { array, func } from 'prop-types';
import { Text } from '../../atoms';
import { Link } from './dynamic-text.styles';

const DynamicText = ({
  data,
  handleClickLink
}) => /*#__PURE__*/React.createElement(React.Fragment, null, data == null ? void 0 : data.map((text, index) => {
  if (typeof text === 'string') return text;
  return text != null && text.href ? /*#__PURE__*/React.createElement(Link, _extends({
    key: index,
    "data-testid": "dynamic-text-link",
    href: text == null ? void 0 : text.href,
    onClick: e => handleClickLink(e, text)
  }, text), text == null ? void 0 : text.value) : /*#__PURE__*/React.createElement(Text, _extends({
    key: index
  }, text, {
    as: "span"
  }), text == null ? void 0 : text.value);
}));

DynamicText.defaultProps = {
  data: [],
  handleClickLink: () => {}
};
process.env.NODE_ENV !== "production" ? DynamicText.propTypes = {
  data: array,
  handleClickLink: func
} : void 0;
export default DynamicText;